import { useEffect, useState } from "react";
import { getImageUrlAdminToken } from "../../utills/ImagesUtilsAdmin";
import {
  TableContainer,
  Table,
  Typography,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Button,
  Box,
  IconButton,
  CircularProgress,
  Grid,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ClearIcon from "@mui/icons-material/Clear";
import {
  fetchInterests,
  updateInterestImage,
} from "../../services/InterestService";
import CustomSnackbar from "../../CustomSnackbar";

const headStyle = {
  border: "1px solid lightgray",
  textAlign: "center",
  // backgroundColor: "#f5f5f5",
  fontWeight: "bold",
};

const rowStyle = {
  border: "1px solid lightgray",
  textAlign: "center",
};

const InterestImages = () => {
  const [image, setImage] = useState([]);
  const [selectedImage, setSelectedImage] = useState({});
  const [previewImage, setPreviewImage] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState({});
  // ----------------------------------- fetchAllInterestImages--------------------------------------
  const fetchInterestImages = async () => {
    setIsLoading(true);
    try {
      const data = await fetchInterests();
      setImage(data);
    } catch (error) {
      console.error("Error fetching images:", error);
      setSnackbarOpen(true);
      setSnackbarMessage("Error fetching images");
      setSnackbarSeverity("error");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchInterestImages();
  }, []);

  // --------------------------------------handleFileChange--------------------------------------
  const handleFileChange = (event, id) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage((prev) => ({ ...prev, [id]: file }));
      setPreviewImage((prev) => ({ ...prev, [id]: URL.createObjectURL(file) }));
    }
  };

  // --------------------------------------updateInterestImage--------------------------------------
  const handleUpdateImage = async (id) => {
    setIsUpdating(prev => ({ ...prev, [id]: true }));
    const formData = new FormData();
    formData.append("interest_image", selectedImage[id]);
    try {
      await updateInterestImage(id, formData);
      setSnackbarOpen(true);
      setSnackbarMessage("Image updated successfully");
      setSnackbarSeverity("success");
      fetchInterestImages();
      setSelectedImage((prev) => ({ ...prev, [id]: null }));
      setPreviewImage((prev) => ({ ...prev, [id]: null }));
    } catch (error) {
      console.error("Error updating image:", error);
      setSnackbarOpen(true);
      setSnackbarMessage("Error updating image");
      setSnackbarSeverity("error");
    } finally {
      setIsUpdating(prev => ({ ...prev, [id]: false }));
    }
  };

  //--------------------------------remove preview image--------------------------------------
  const handleRemovePreview = (id) => {
    setPreviewImage((prev) => ({ ...prev, [id]: null }));
    setSelectedImage((prev) => ({ ...prev, [id]: null }));
  };

  return (
    <TableContainer component={Grid}>
      <Typography
        variant="h6"
        component="div"
        sx={{ textAlign: "center", pb: 2 }}
      >
        Update Interest Images
      </Typography>
      {isLoading ? (
        <Box display="flex" justifyContent="center" p={3}>
          <CircularProgress />
        </Box>
      ) : (
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={headStyle}>ID</TableCell>
              <TableCell sx={headStyle}>Interest</TableCell>
              <TableCell sx={headStyle}>Image</TableCell>
              <TableCell sx={headStyle}>Update Images</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {image.map((row) => (
              <TableRow key={row.id}>
                <TableCell sx={rowStyle}>{row.id}</TableCell>
                <TableCell sx={rowStyle}>{row.interest_name}</TableCell>
                <TableCell sx={rowStyle}>
                  <Box sx={{ position: "relative", display: "inline-block" }}>
                    <Box
                      component="img"
                      sx={{
                        height: 100,
                        width: 100,
                        objectFit: "cover",
                        borderRadius: 1,
                      }}
                      alt={row.image_alt}
                      src={
                        previewImage[row.id]
                          ? previewImage[row.id]
                          : row.interest_image
                          ? getImageUrlAdminToken(row.interest_image)
                          : "No Image"
                      }
                    />
                    {previewImage[row.id] && (
                      <IconButton
                        sx={{
                          position: "absolute",
                          backgroundColor: "red",
                          top: 0,
                          right: 0,
                          color: "white",
                          height: 20,
                          width: 20,
                        }}
                        onClick={() => handleRemovePreview(row.id)}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </Box>
                </TableCell>
                <TableCell sx={rowStyle}>
                  {selectedImage[row.id] ? (
                    <Button
                      variant="contained"
                      onClick={() => handleUpdateImage(row.id)}
                      disabled={isUpdating[row.id]}
                    >
                      {isUpdating[row.id] ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        'Update Image'
                      )}
                    </Button>
                  ) : (
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<CloudUploadIcon />}
                    >
                      Upload Image
                      <input
                        type="file"
                        hidden
                        onChange={(event) => handleFileChange(event, row.id)}
                      />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />
    </TableContainer>
  );
};

export default InterestImages;
